import axios from 'axios'
import {
  LaundryModel,
  Reception,
  ResponseCRUD,
  ResponseObject,
  TypeClothe,
  ResponseObjectPaginated,
  ResponseObjectURL,
  DataDashboardMaintenanceInspectionModel,
} from '../model'
import {
  LaundryFrecuencyModel,
  LaundryFrecuencySearchModel,
} from '../features/laundryFrecuency/model/laundryFrecuency.model'
import {
  LaundryWashingTimeModel,
  LaundryWashingTimeSearchModel,
} from '../features/laundryFrecuency/model/laundryWashingTime.model'

const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getLaundry(dto: LaundryModel, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryModel[]>>(`${BASEURL}/order/getAll/${page}`, dto)
}
export function getLaundryById(dto: string | undefined) {
  return axios.get<ResponseObject<LaundryModel>>(`${BASEURL}/order/getInformationById?id=${dto}`)
}

export function createLaundry(dto: LaundryModel) {
  return axios.post<any>(`${BASEURL}/order/createOrder`, dto)
}

export function deleteLaundry(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/order/deleteOrder?id=${dto}`)
}

export function updateLaundry(dto: LaundryModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/order/updateOrder`, dto)
}

// RECEPTION - OUT LAUNDRY

export function createReceptionLaundry(dto: any) {
  return axios.post<ResponseObjectPaginated<Reception>>(`${BASEURL}/order/createReception`, dto)
}
export function createOutLaundry(dto: any) {
  return axios.post<ResponseObjectPaginated<LaundryModel[]>>(`${BASEURL}/order/createOutput`, dto)
}

// RECEPTION MASIVE

export function createReceptioMasive(dto: LaundryModel) {
  return axios.post<ResponseObjectPaginated<LaundryModel[]>>(
    `${BASEURL}/order/massiveReception`,
    dto,
  )
}

// OUT MASIVE

export function createOutMasive(dto: LaundryModel) {
  return axios.post<ResponseObjectPaginated<LaundryModel[]>>(`${BASEURL}/order/massiveOutput`, dto)
}

// RECEPTION BY LAUNDRY

export function getReceptionByLaundry(dto: any, page: number) {
  return axios.post<ResponseObjectPaginated<TypeClothe[]>>(
    `${BASEURL}/order/getReceptionDetail?receptionId=${dto}&pageNumber=${page}`,
  )
}

export function createReceptionByLaundry(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/createDetailReception`, dto)
}

export function deleteReceptionByLaundry(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/order/deleteDetailReception?id=${dto}`)
}

export function updateReceptionByLaundry(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/updateDetailReception`, dto)
}

// Wash BY LAUNDRY

export function createWashByLaundry(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/createProcesswashingOrder`, dto)
}

export function updateWashByLaundry(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/updateProcesswashingOrder`, dto)
}

// PRINT LAUNDRY
export function getPrintOrderReception(dto: any) {
  return axios.get<any>(`${BASEURL}/order/printReceptionOrder?ordenId=${dto}`, {
    responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
  })
}

export function getOrderReception(dto: any) {
  return axios.get<any>(`${BASEURL}/order/getReceptionOrderText?ordenId=${dto}`)
}
export function getSendEmailReception(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/sendReceptionOrder?ordenId=${dto}`)
}
export function getPrintOrderOut(dto: any) {
  return axios.get<any>(`${BASEURL}/order/printOutputOrder?ordenId=${dto}`, {
    responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
  })
}
export function getOrderOut(dto: any) {
  return axios.get<any>(`${BASEURL}/order/getOutputOrderText?ordenId=${dto}`)
}
export function getSendEmailOut(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/sendOutputOrder?ordenId=${dto}`)
}

// TICKET LAUNDRY
export function downloadTemplateTicket() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/order/downloadTemplatePrintSelfAdhesiveLabelReceptionMassive`,
  )
}

export function downloadTemplateTicketV() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/order/downloadTemplatePrintSelfAdhesiveLabelReceptionMassive_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveTicket(dto: any) {
  return axios.post<any>(`${BASEURL}/order/printSelfAdhesiveLabelReceptionMassive`, dto, {
    responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
  })
}

export function uploadTicket(dto: any) {
  return axios.get<any>(`${BASEURL}/order/printSelfAdhesiveLabelReception?ordenId=${dto}`, {
    responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
  })
}

// FRECUENCY
// Laundry Frecuency
export function getLaundryFrecuency(dto: LaundryFrecuencySearchModel) {
  return axios.post<ResponseObjectPaginated<LaundryFrecuencyModel[]>>(
    `${BASEURL}/order/getLaundryFrequencyReport/${dto.pageNumber}`,
    dto,
  )
}
export function getLaundryFrecuencyReportPDF(dto: LaundryFrecuencySearchModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryFrequencyReportPDF`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getLaundryFrecuencyReportXLS(dto: LaundryFrecuencySearchModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryFrequencyReportExcel`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getLaundryFrecuencyReportCSV(dto: LaundryFrecuencySearchModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryFrequencyReportCSV`, dto, {
    responseType: 'arraybuffer',
  })
}

// Laundry Washing Time
export function getLaundryWashingTime(dto: LaundryWashingTimeSearchModel, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryWashingTimeModel[]>>(
    `${BASEURL}/order/getWashingTimeReport/${page}`,
    dto,
  )
}

export function getLaundryWashingTimeReportPDF(dto: LaundryFrecuencySearchModel) {
  return axios.post<any>(`${BASEURL}/order/getWashingTimeReportPDF`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getLaundryWashingTimeReportXLS(dto: LaundryFrecuencySearchModel) {
  return axios.post<any>(`${BASEURL}/order/getWashingTimeReportExcel`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getLaundryWashingTimeReportCSV(dto: LaundryFrecuencySearchModel) {
  return axios.post<any>(`${BASEURL}/order/getWashingTimeReportCSV`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getDataDashboardMaintenanceInspection(dto: any) {
  return axios.post<ResponseObject<DataDashboardMaintenanceInspectionModel>>(
    `${BASEURL}/maintenanceinspection/getDataDashboardMaintenanceInspection`,
    dto,
  )
}
